export const MOBILE_KEY = 'mobile';
export const MOBILE_WIDTH = 576;

export const TABLET_KEY = 'tablet';
export const TABLET_WIDTH = 1200;

export const DESKTOP_KEY = 'desktop';
